import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/observable/of";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import { from as from$ } from "rxjs/observable/from";
import { of as of$ } from "rxjs/observable/of";
import * as CreDtos from "../CRE.dtos";
import { forumApi } from "../services/forum";
const queryString = require('query-string');

import {

    SEARCH_MEMBER_REQUEST,
    searchMemberSuccess,
    searchMemberFailure,
    
    SAVE_MEMBER_REQUEST,
    saveMemberSuccess,
    saveMemberFailure,
    
    GET_MEMBER_REQUEST,
    getMemberSuccess,
    getMemberFailure,
    SET_NOTIFICATION_REQUEST,
    setNotificationSuccess,
    setNotificationFailure,
    SET_EMAIL_UPDATE_REQUEST,
    setUpdateFrequencySuccess,
    setUpdateFrequencyFailure,
    
    } from "../actions/members.actions";
import { getForumListRequest, getForumRequest } from "../actions/forum.actions";


export const setNotificationFrequencyEpic = action$ =>
    action$
      .ofType(SET_EMAIL_UPDATE_REQUEST)
      .mergeMap(action =>
        forumApi
          .setNotificationFrequency(action.value)
          .mergeMap( response => { 
            return concat$(Observable.of(setUpdateFrequencySuccess(action.value)) ); 
          })
          .catch(error => {
              return Observable.of(setUpdateFrequencyFailure(error.responseStatus))
            }
          )
      );

  export const setNotificationActiveEpic = action$ =>
      action$
        .ofType(SET_NOTIFICATION_REQUEST)
        .mergeMap(action =>
          forumApi
            .setNotificationActive(action.value)
            .mergeMap( response => { 
              return concat$(Observable.of(setNotificationSuccess(action.value)) ); 
            })
            .catch(error => {
                return Observable.of(setNotificationFailure(error.responseStatus))
              }
            )
        );
export const getMemberEpic = action$ =>
    action$
      .ofType(GET_MEMBER_REQUEST)
      .mergeMap(action =>
        forumApi
          .getMember(action.id)
          .mergeMap( (response:CreDtos.ForumMemberResponse) => { 
            var member = response.member;
            /* On getting the logged in user check for a specific forum and go there */
            var queryStringParam = queryString.parse(location.search);
            var forumId = queryStringParam.id;
            var newAction = forumId ? Observable.of(getForumRequest(forumId, false)) : Observable.of(getForumListRequest(member.email));
            
            return concat$(Observable.of(getMemberSuccess(response)), newAction ); 
          })
          .catch(error => {
              return Observable.of(getMemberFailure(error.responseStatus))
            }
          )
      );

export const saveMemberEpic = action$ =>
  action$
    .ofType(SAVE_MEMBER_REQUEST)
    .mergeMap(action =>
      forumApi
        .saveMember(action.id, action.member)
        .map(response => { 
          let savedMember = action.member;
          savedMember.id = (<CreDtos.ForumMemberResponse>response).member.id;
          if(savedMember.password != undefined && savedMember != ""){
            forumApi.saveMemberPassword(savedMember.forumId, savedMember);
          }
          return saveMemberSuccess(response);
        })
        .catch(error =>
          Observable.of(saveMemberFailure(error.responseStatus))
        )
    );


export const searchMemberEpic = action$ =>
    action$
      .ofType(SEARCH_MEMBER_REQUEST)
      .mergeMap(action =>
        forumApi
          .searchMembers(action.id, action.term)
          .map(response => searchMemberSuccess(response))
          .catch(error =>
            Observable.of(searchMemberFailure(error.responseStatus))
          )
      );    


// WEBPACK FOOTER //
// ./src/epics/members.epic.ts